import { types } from 'mobx-state-tree';


const TITLES = {
    MR: 'mr',
    MS: 'ms',
    MRS: 'mrs',
    MISS: 'miss',
    DR: 'dr',
    OTHER: 'other',
};

const TitlesEnum = types.enumeration('Titles', Object.values(TITLES));

export {
    TitlesEnum,
};
export default TITLES;
